import { useQuery } from "@tanstack/react-query";

import getCartProducts from "@/actions/navbar/get-cart-products";

export default function useGetCartProducts() {
  return useQuery({
    queryKey: ["cart-data"],
    queryFn: () => getCartProducts(),
  });
}
